export default "__VITE_ASSET__23157351__"